/**
 * Notifications API services
 */

import apiClient from './client';

export interface Notification {
  id: string;
  tenantId: string;
  userId: string;
  instanceId?: string;
  notificationType: string;
  title: string;
  message: string;
  isRead: boolean;
  readAt?: string;
  createdAt: string;
}

export interface NotificationList {
  notifications: Notification[];
  total: number;
  unreadCount: number;
}

export interface NotificationCount {
  unreadCount: number;
  total: number;
}

const transformNotification = (data: any): Notification => ({
  id: data.id,
  tenantId: data.tenant_id,
  userId: data.user_id,
  instanceId: data.instance_id,
  notificationType: data.notification_type,
  title: data.title,
  message: data.message,
  isRead: data.is_read,
  readAt: data.read_at,
  createdAt: data.created_at,
});

export const notificationsApi = {
  list: async (params?: { unreadOnly?: boolean; limit?: number; offset?: number }): Promise<NotificationList> => {
    const queryParams: any = {};
    if (params?.unreadOnly !== undefined) queryParams.unread_only = params.unreadOnly;
    if (params?.limit !== undefined) queryParams.limit = params.limit;
    if (params?.offset !== undefined) queryParams.offset = params.offset;

    const response = await apiClient.get('/v1/notifications', { params: queryParams });
    return {
      notifications: response.data.notifications.map(transformNotification),
      total: response.data.total,
      unreadCount: response.data.unread_count,
    };
  },

  getCount: async (): Promise<NotificationCount> => {
    const response = await apiClient.get('/v1/notifications/count');
    return {
      unreadCount: response.data.unread_count,
      total: response.data.total,
    };
  },

  markAsRead: async (notificationIds: string[]): Promise<void> => {
    await apiClient.post('/v1/notifications/mark-read', {
      notification_ids: notificationIds,
    });
  },

  markAllAsRead: async (): Promise<void> => {
    await apiClient.post('/v1/notifications/mark-all-read');
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/v1/notifications/${id}`);
  },
};
